// Dashboard translation (TASK-036, plans/REDESIGN.md phase 3). The studio's pattern: the
// English and Arabic text sit together where they are used, t('Save', 'حفظ'), and the
// interface language comes from the EN / عربي switch (utils/ui-language.js). Screens are
// translated as they are redesigned; until then they show their English text, mirrored.
import { useUiLang } from './ui-language'

export function useT() {
  const [lang] = useUiLang()
  const ar = lang === 'ar'
  const t = (en, arText) => (ar && arText ? arText : en)
  return { t, lang, dir: ar ? 'rtl' : 'ltr', ar }
}

// Numbers and dates in the interface language (Latin digits for both, as the studio).
export const localeOf = (lang) => (lang === 'ar' ? 'ar-u-nu-latn' : 'en-US')
